export default "__VITE_ASSET__869598d5__"